import { Component } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { MenubarModule } from 'primeng/menubar';
import { MenuItem } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { AuthService } from '../../../core/services/auth.service';

@Component({
  selector: 'app-admin-layout',
  standalone: true,
  imports: [RouterModule, MenubarModule, ButtonModule],
  templateUrl: './admin-layout.component.html',
  styleUrls: ['./admin-layout.component.css']
})
export class AdminLayoutComponent {
  constructor(
    private authService: AuthService,
    private router: Router
  ) {}
  menuItems: MenuItem[] = [
    {
      label: 'Dashboard',
      icon: 'pi pi-home',
      routerLink: ['/admin/dashboard']
    },
    {
      label: 'Catalog',
      icon: 'pi pi-shopping-bag',
      items: [
        {
          label: 'Categories',
          icon: 'pi pi-tags',
          routerLink: ['/admin/categories']
        },
        {
          label: 'Products',
          icon: 'pi pi-box',
          routerLink: ['/admin/products']
        }
      ]
    }
  ];

  logout() {
    this.authService.logout();
    this.router.navigate(['/login']);
  }
}
